import { Controller } from '@hotwired/stimulus'
import {
  computePosition,
  flip,
  shift,
  offset,
  size
} from '@floating-ui/dom'

const OFFSET = 8 // px

// Connects to data-controller="dropdown-floating"
export default class extends Controller {
  static targets = ['button', 'menu']
  static values = {
    position: { type: String, default: 'bottom-start' },
    maxHeight: { type: Number, default: null }
  }

  connect () {
    this.isOpen = false
  }

  toggle (event) {
    event.preventDefault()
    event.stopPropagation()

    if (this.isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  open () {
    this.isOpen = true
    this.menuTarget.removeAttribute('hidden')
    this.updatePosition()

    // Add click outside listener
    document.addEventListener('click', this.handleClickOutside)
  }

  close () {
    this.isOpen = false
    this.menuTarget.setAttribute('hidden', '')

    // Remove click outside listener
    document.removeEventListener('click', this.handleClickOutside)
  }

  handleClickOutside = (event) => {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  updatePosition () {
    const maxHeight = this.maxHeightValue
    computePosition(this.buttonTarget, this.menuTarget, {
      placement: this.positionValue,
      middleware: [
        flip(),
        shift({ padding: OFFSET }),
        offset(OFFSET),
        size({
          apply ({ availableWidth, availableHeight, elements }) {
            if (maxHeight) {
              availableHeight = Math.min(availableHeight, maxHeight)
            }
            Object.assign(elements.floating.style, {
              maxWidth: `${Math.max(0, availableWidth)}px`,
              maxHeight: `${Math.max(0, availableHeight)}px`
            })
          }
        })
      ]
    }).then(({ x, y }) => {
      Object.assign(this.menuTarget.style, {
        position: 'absolute',
        top: `${y}px`,
        left: `${x}px`,
        zIndex: '99999'
      })
    })
  }
}
